<template>
    <span class="copy-text">
        <button class="button button_command copy-text__button"
                style="float: right;"
                @click="copyText(text)">
            <SvgIcon name="common__copy"/>
        </button>

        {{text}}
    </span>
</template>

<script>
import copyMixin from "@/mixins/copyMixin";
import {useToast} from "vue-toastification";

export default {
    name: "CopyTextComponent",
    props: {
        text: String,
    },
    mixins: [copyMixin],
    data() {
        return {
            toast: useToast()
        }
    },
    methods: {
    }
}
</script>

<style lang="scss" scoped>
.copy-text {
    display: block;
    align-items: center;
    &__button {
        color: inherit;
        position: relative;
    }
}
</style>